module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-hide"
  }, [_c('div', {
    staticClass: "context card_bind_context"
  }, [_c('div', {
    staticClass: "top-context-parent"
  }, [_c('div', {
    staticClass: "top-context"
  }, [_c('div', {
    staticClass: "top-from"
  }, [_c('div', {
    staticClass: "btop_tip"
  }, [_vm._v("请输入您的会员卡号")]), _vm._v(" "), _c('div', {
    staticClass: "button-one card-in"
  }, [_c('div', {
    staticClass: "in_tip"
  }, [_vm._v("卡号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.card_num),
      expression: "card_num"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.card_num)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.card_num = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btop_tip"
  }, [_vm._v("请输入您的手机号码")]), _vm._v(" "), _c('div', {
    staticClass: "button-two phone-in"
  }, [_c('div', {
    staticClass: "in_tip"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cust_mobile),
      expression: "cust_mobile"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cust_mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cust_mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btop_tip"
  }, [_vm._v("请点击“获取验证码”按钮，填写您收到的验证码")]), _vm._v(" "), _c('div', {
    staticClass: "button-three "
  }, [_c('div', {
    staticClass: "in_tip"
  }, [_vm._v("验证码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.card_bind_vcode),
      expression: "card_bind_vcode"
    }],
    staticClass: "input-text",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.card_bind_vcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.card_bind_vcode = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.sendMsgDisabled) ? _c('div', {
    staticClass: "button-four",
    on: {
      "click": _vm.getSession
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.sendMsgDisabled) ? _c('div', {
    staticClass: "button-four"
  }, [_c('a', {
    staticClass: "waitTime"
  }, [_vm._v(_vm._s(_vm.time + '秒'))])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "next-button"
  }, [_c('input', {
    staticClass: "bangding",
    attrs: {
      "type": "button",
      "value": "绑定"
    },
    on: {
      "click": _vm.bindup
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "success hdiv"
  }, [_c('div', {
    staticClass: "cover"
  }), _vm._v(" "), _c('div', {
    staticClass: "cover-content"
  }, [_c('div', {
    staticClass: "success-text"
  }, [_c('p', [_vm._v("绑定成功")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "确定"
    },
    on: {
      "click": _vm.goQrcode
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "fail hdiv"
  }, [_c('div', {
    staticClass: "cover"
  }), _vm._v(" "), _c('div', {
    staticClass: "cover-content"
  }, [_c('img', {
    attrs: {
      "src": "http://style.cdn.juhaomai.net/style/game/huiyuanbangding/images/v2/sorry.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fail-text"
  }, [_c('p', [_vm._v(_vm._s(_vm.err_msg))]), _vm._v(" "), _c('p'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "确定"
    },
    on: {
      "click": _vm.closeAgain
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "again hdiv"
  }, [_c('div', {
    staticClass: "cover"
  }), _vm._v(" "), _c('div', {
    staticClass: "cover-content"
  }, [_c('img', {
    attrs: {
      "src": "http://style.cdn.juhaomai.net/style/game/huiyuanbangding/images/v2/again.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "again-text"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "电话告诉我验证码"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "pass",
    attrs: {
      "type": "button",
      "value": "取消"
    },
    on: {
      "click": _vm.closePhone
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "get-start"
  }, [_vm._v("获取验证码"), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c612defe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/main/views/card_bind.vue
// module id = 222
// module chunks = 1